import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { LangContext } from '../contexts/langContext';
import { SocialContext } from '../contexts/socialContext';
import { StateContext } from '../contexts/stateContext';
import { Avatar } from './UiKit/Avatar';
import { AvatarName } from './UiKit/AvatarName';
import { UserSocialLine } from './UiKit/AvatarPanel';
import { Background } from './UiKit/Background';
import { City } from './UiKit/City';
import { Icon } from './UiKit/Icon';
import { Preloader, Preloader0, PreloaderButton } from './UiKit/kit';
import { Preview } from './UiKit/Preview';
import { ProfileCircle } from './UiKit/ProfileCircle';
import { UserDropDown } from './UiKit/UserDropDown';
import { Svg } from './UiKit/Svg';
import { DefinitionIcon } from './UiKit/DefinitionIcon';
import { TooltipH, PopoverH } from './UiKit/TooltipH';
import { Astro, AstroSocial } from './Edu/Astro';
import { JyotishSocial } from './Edu/Jyotish';
import { cleanPersonaHash } from './utilsSocial';


export function PersonaMinimal(props) {

  const {
    width,
    height,
    noClick,
    active,
    customHandler,
    listId = 1,
    user,
    avatar,
    panelExpanded,
    actions = [],
    // isMe,
    fullList,
    followings = [],
    followers = [],
    refetch = () => void (0),
    addLine = 'city', //'followings'/'city'/'followers'/'none',
    noInfo = false,
    addClassName = 'people',
    hideName,
    celeb,
    splits = true,
    mode = 'hd'
  } = { ...props };



  const context = {
    ...useContext(SocialContext),
    ...useContext(StateContext),
    ...useContext(LangContext)
  };
  const $ui = context.$ui;
  const $celebType = context.$celebType;
  const isMe = context.me ? avatar.token === context.me.avatar.token : false;

  // const design = context.x.getDesign(avatar);
  const design = avatar.design && avatar.design['id'] !== 'dummy' ? avatar.design : null;
  const navigate = useNavigate();
  const location = useLocation();

  const navigateToUser = (token) => {
    context.setState.showPeoplePanel(false);
    const studyMatch = location.pathname.match(/^\/u\/[^/]+\/(study\/.*)$/);
    const path = studyMatch ? `/u/${token}/${studyMatch[1]}` : `/u/${token}`;
    navigate(`${path}${location.search}${cleanPersonaHash(location.hash)}`);
  };

  const { useravatarId } = useParams();
  const bodyContainer = useRef(null);

  const [activeInner, setActive] = useState(active)


  const desC = design && design.des ? design.des.toLowerCase() : '';
  const prsC = design && design.prs ? design.prs.toLowerCase() : '';
  const typC = design && design.type ? design.type.toLowerCase() : '';


  useEffect(() => {
    if (!noClick && useravatarId && (user || avatar)) {
      let userToken = user ? user.token : null;
      let avatarToken = avatar ? avatar.token : null;
      setActive(useravatarId === userToken || useravatarId === avatarToken)
    }
  }, [useravatarId, user, avatar])



  const isFriend = () => {
    if (!user || !context.me) return true;
    const arrayFollowings = context.followings ? context.followings : [];
    let friendsTokens = arrayFollowings.filter(one => one?.user?.token).map(one => one.user.token)
    friendsTokens.push(context.me.user.token)
    if (friendsTokens.includes(user.token)) return true;
  }

  // const isCeleb = () => {
  //   console.log('user = ', user);
  //   if (!user) return false;
  //   const celebs = Object.keys(context.celebs);
  //   if (user && celebs.includes(user.token)) return true;
  // }
  const isCeleb = () => {
    return panelExpanded && celeb
  }

  const hasDesign = design && design['id'] && design['id'] !== 'dummy';


  return (
    <>
      <div
        className="_rel"
      >



        <div className="x_choose_user_actionable">

          {!user && (!design || design.type === 'dummy') && <div className="x_choose_user_ava">

            {/* {design && avatar && Boolean(avatar.image) && <div className="x_choose_user_ava_image"
    style={{ backgroundImage: avatar.image ? `url(${avatar.image})` : '' }}
  />} */}



            {/* {design && user && !Boolean(avatar.image) && <div className={`t_icon t_icon--ava ${getAvatarClass(design)}`}
  >no_accounts</div>} */}

            {/* {design && <Icon size={40}>qr_code</Icon>} */}

            {!design && <Icon size={40}>question_mark</Icon>}

          </div>}

          {design
            && avatar
            // && !isCeleb()
            // && !Boolean(user && user.token)
            && !isCeleb()
            && <Avatar
              avatar={avatar}
              mode={mode}
              size={panelExpanded && isCeleb() ? 'lg' : 'sm'}
            // type='lg'
            />}


          <div className={`x_choose_user_info ${
            // isCeleb() &&
            isCeleb() ? 'x_choose_user_info--celeb' : ''}`}>

            {avatar && <div className="x_choose_user_nick ellipsis">
              {/* <div className="x_choose_user_badge" /> */}
              {/* {user ? user.name : avatar.name} */}
              <AvatarName avatar={avatar} hideName={hideName} />
            </div>}
            {user && addLine === 'followings' && <div className='x_choose_user_2nd'>
              {user.aggr && user.aggr.followers_count && <div>{user.aggr.followings_count} {$ui('persona_friends_count')}</div>}
            </div>}
            {user && addLine === 'city' && <div className='x_choose_user_2nd'>
              {user.aggr && user.aggr.city && <div>{user.aggr.city.city}</div>}
            </div>}

            {/* {addLine !== 'none' && !user && design && design['id'] !== 'dummy' && <div>{$ui('persona_invite')}</div>} */}

            {!user && !design && <div>{$ui('persona_setup')}</div>}


          </div>



        </div>



        {!noClick
          && <div className={activeInner ? "x_hover active" : "x_hover"}
            onClick={() => {
              if (!noClick) {
                if (customHandler) {
                  customHandler({
                    user: user,
                    avatar: avatar
                  })
                } else {
                  navigateToUser(user ? user.token : avatar.token);
                }
              }
            }}
          />}

        {!noClick
          && <div className="x_mobile_tap"
            onClick={() => {
              if (!noClick) {
                if (customHandler) {
                  customHandler({
                    user: user,
                    avatar: avatar
                  })
                } else {
                  navigateToUser(user ? user.token : avatar.token);
                }
              }
            }}
          />}


      </div>
    </>
  )
}